export const itdageneWordmark = {
  height: 444,
  markWidth: 444,
  src: '/static/itdagene-svart.png',
  width: 1961,
} as const;
